import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Card, CardContent, Typography } from "../../../../components";
import { Divider, Skeleton } from "@mui/material";
import { MonitorFinanceiroService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const monitorFinanceiroService = new MonitorFinanceiroService();

const CORES = {
  "Entradas Previstas": "#388e3c",
  "Saídas Previstas": "#d32f2f",
  "Saldo Previsto": "#1976d2",
};

function MonitorFinFluxoPrevisto({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ categories: [], series: [] });

  useEffect(() => {
    buscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscar() {
    setLoading(true);
    const result =
      await monitorFinanceiroService.getDashboardFluxoPrevisto(filtrosBody);
    if (!result.isAxiosError) {
      setData(result.data || { categories: [], series: [] });
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const semDados = !data.categories?.length;

  const chartOptions = {
    chart: { type: "line", height: 300, spacing: [10, 10, 10, 10] },
    title: { text: "" },
    credits: { enabled: false },
    xAxis: {
      categories: data.categories,
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      title: { text: "" },
      labels: {
        style: { fontSize: "10px" },
        formatter: function () {
          return formatPrice(this.value);
        },
      },
      plotLines: [{ value: 0, color: "#cbd5e1", width: 1 }],
    },
    legend: { enabled: true, itemStyle: { fontSize: "11px" } },
    tooltip: {
      shared: true,
      useHTML: true,
      backgroundColor: "#fff",
      borderWidth: 0,
      borderRadius: 4,
      formatter: function () {
        const rows = this.points
          .map(
            (p) =>
              `<span style="color:${p.color}">●</span> ${
                p.series.name
              }: <b>${formatPrice(p.y)}</b>`,
          )
          .join("<br/>");
        return `<b>${this.x}</b><br/>${rows}`;
      },
    },
    plotOptions: {
      line: { marker: { enabled: true, radius: 3 } },
    },
    series: (data.series || []).map((s) => ({
      name: s.name,
      data: s.data,
      color: CORES[s.name],
      dashStyle: s.name === "Saldo Previsto" ? "ShortDot" : "Solid",
    })),
  };

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Fluxo de Caixa Previsto · Próximos 30 Dias
          </Typography>
          <i
            className="ph-bold ph-chart-line-up"
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 1 }} />
        ) : semDados ? (
          <Box display="flex" justifyContent="center" py={6}>
            <Typography variant="body2" color="text.secondary">
              Sem títulos previstos para os próximos 30 dias.
            </Typography>
          </Box>
        ) : (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        )}
      </CardContent>
    </Card>
  );
}

export default MonitorFinFluxoPrevisto;
